import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
	0% { background-position: -300px 0; }
	100% { background-position: 300px 0; }
`;

export const SummaryContainer = styled.div`
	border: 1px dashed #7792f1;
	border-radius: 16px;
	padding: 15px 16px;
	margin-top: 12px;
	color: #ffffff;
	font-size: 12px;
	line-height: 1.55;
	font-family: "NotoSans-Regular", sans-serif;
	width: 100%;
	text-align: left;

	.summary-skeleton {
		height: 11px;
		border-radius: 5px;
		margin: 2px 0 9px;
		background: linear-gradient(90deg, #20306d 25%, #354784 50%, #20306d 75%);
		background-size: 600px 100%;
		animation: ${shimmer} 1.3s infinite linear;
	}

	.summary-skeleton.short {
		width: 68%;
		margin-bottom: 1px;
	}

	button {
		border: 0;
		background: transparent;
		color: #2effb2;
		font: inherit;
		font-weight: 700;
		text-decoration: underline;
		cursor: pointer;
	}
`;

export const HighlightText = styled.strong`
	font-family: "NotoSans-Bold", sans-serif;
	font-weight: bold;
	margin-right: 6px;
	color: #ffffff;
`;
